export default function AND() {
  return (
    <div className="p-4">
      <h1>AND</h1>
    </div>
  );
}
